import Vue from 'vue';
import { Plans } from '@resources/js/constants/campaign.constants';

Vue.mixin({
  methods: {
    getPlanFeatures(plan, allPlans = []) {
      if (plan.id === Plans.FREE) {
        const freeStyle = { icon: 'fa-check-circle', iconClass: 'primary-color' };
        return [
          { label: 'Basic site', ...freeStyle },
          { label: 'Updates - Social Feed', ...freeStyle },
          { label: 'Image and Video support', ...freeStyle },
          { label: 'Donations through ActBlue or DemEngine: Pledge only support and Tiered giving', ...freeStyle },
          { label: 'Campaign Alerts', ...freeStyle },
          { label: 'Online help', ...freeStyle },
          { label: 'Private/public campaign launch', ...freeStyle },
          { label: 'Basic Analytics', ...freeStyle },
        ];
      }

      const planOrder = [Plans.LOCAL, Plans.REGIONAL, Plans.STATE_NATIONAL, Plans.CUSTOM];

      let previousPlan = null;
      if (allPlans?.length) {
        const currentPlanIndex = planOrder.indexOf(plan.id);
        if (currentPlanIndex > 0) {
          const previousPlanId = planOrder[currentPlanIndex - 1];
          previousPlan = allPlans.find(p => p.id === previousPlanId);
        }
      }

      const featureConfig = [
        {
          label: `${plan.id === Plans.CUSTOM ? 'Custom Email Sends' : `${plan.email_limit} Email Sends / month`}`,
          isBoolean: false,
        },
        {
          label: `${plan.id === Plans.CUSTOM ? 'Unlimited Contact Storage' : `Up to ${plan.contacts_limit || 0} Supporters`}`,
          isBoolean: false,
        },
        {
          label: 'Email Provider Contact Sync (up to 2,000)',
          isBoolean: false,
        },
        {
          label: 'CSV Contact Upload',
          isBoolean: false,
        },
        {
          label: 'Multiple Admins',
          isBoolean: false,
        },
        {
          label: 'Supporter and Group DMs',
          property: 'supporter_group_dms',
        },
        {
          label: 'Eligible for Promotion on CrowdBlue',
          property: 'eligible_promotion',
        },
        {
          label: 'Virtual events',
          property: 'virtual_events',
        },
        {
          label: 'Live chat support',
          property: 'live_chat_support',
        },
        {
          label: 'Live phone support',
          property: 'live_phone_support',
        },
        {
          label: 'Campaign Kickstart Session',
          property: 'campaign_kickstart_session',
        },
        {
          label: 'Custom URL',
          property: 'custom_urls',
        },
      ];

      return featureConfig.map(config => {
        let icon, iconClass, textClass;

        if (config.isBoolean === false) {
          icon = 'fa-check-circle';
          iconClass = 'primary-color';
        } else {
          const value = plan[config.property];
          if (value) {
            const isNewFeature = previousPlan && !previousPlan[config.property];
            icon = 'fa-check-circle';
            iconClass = isNewFeature ? 'secondary-color' : 'primary-color';
          } else {
            icon = 'fa-times-circle';
            iconClass = 'neutral-2-color';
            textClass = 'neutral-2-color';
          }
        }

        return {
          label: config.label,
          icon,
          iconClass,
          textClass,
        };
      });
    },
  },
});
